import WhitelabelRoot from './Whitelabel';

const WhitelabelEdit = () => import(/* webpackChunkName: "whitelabel" */ './WhitelabelEdit');
const WhitelabelList = () => import(/* webpackChunkName: "whitelabel" */ './WhitelabelList');
const WhitelabelRegister = () => import((/* webpackChunkName: "whitelabel" */ './WhitelabelRegister'));

export default {
  path: '/domains',
  name: 'domains',
  component: WhitelabelRoot,
  children: [{
    path: 'register',
    name: 'domainsRegister',
    component: WhitelabelRegister,
  }, {
    path: 'all',
    name: 'domainsList',
    component: WhitelabelList,
  }, {
    path: 'create',
    name: 'domainsCreate',
    component: WhitelabelEdit,
  }, {
    path: ':domainId',
    name: 'domainsEdit',
    component: WhitelabelEdit,
    props: true,
  }],
};